function arriving_today_Reducer(state = null, action) {
    switch (action.type) {
        case 'ARRIVING_TODAY/SET':
            return action.bookings;
        case 'ARRIVING_TODAY/CLEAR':
            return null;
        default:
            return state;
    }
}

export default arriving_today_Reducer;
